<template lang="pug">
  .modal.modal--sm
    p.modal__text(
    :class="{ 'modal__text--center': modalData.alignCenter }"
    ) {{ modalData.text }}
    .modal__buttons-container
      button.button.button_paint-main.button_full(
      @click="onClickApproveButton"
      )
        .button__text Да
      button.button.button_full(
      @click="onClickCancelButton"
      )
        .button__text Нет

</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "confirm-reserve",
  props: ["modalData"],
  methods: {
    ...mapActions(["updateOrderStatus"]),
    onClickApproveButton() {
      //Здесь 4 - id статуса "В резерве"
      this.updateOrderStatus({ id: this.modalData.id, status: 4 }).then(
        (res) => {
          if (res.status === 200) {
            this.$emit("changeModalMode", "notification", {
              title: "Успешно",
              text: "Заявка добавлена в резерв",
              redirectToRequests: true,
            });
          } else {
            this.$emit("changeModalMode", "notification", {
              title: "Ошибка",
              text: "Попробуйте повторить позже",
            });
          }
        }
      );
    },
    onClickCancelButton() {
      this.$emit("close");
    },
  },
};
</script>
